
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"12","viewBox":"0 0 18 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#979797","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"4","cy":"2","r":"2"}}),_c('circle',{attrs:{"cx":"14","cy":"2","r":"2"}}),_c('path',{attrs:{"d":"M13 12v-2c0-.311-.133-.622-.4-.8-.533-.444-1.244-.756-1.956-.933C10.156 8.133 9.578 8 9 8c-.533 0-1.111.089-1.644.267-.712.177-1.378.533-1.956.933-.267.222-.4.489-.4.8v2h8z"}}),_c('circle',{attrs:{"cx":"9","cy":"5","r":"2"}}),_c('path',{attrs:{"d":"M17.613 6.2c-.515-.444-1.202-.756-1.89-.933-.471-.134-1.03-.267-1.588-.267-.515 0-1.074.089-1.589.267-.258.089-.515.177-.773.31v.045c0 .756-.3 1.467-.773 1.956.816.266 1.46.622 1.975 1.022.13.133.258.222.344.4H18V7c0-.311-.129-.622-.387-.8zM5.025 8.6A7.007 7.007 0 017 7.578c-.472-.534-.773-1.2-.773-1.956v-.089c-.258-.089-.515-.222-.773-.266C4.982 5.133 4.424 5 3.865 5c-.515 0-1.074.089-1.589.267a6.88 6.88 0 00-1.89.933C.13 6.378 0 6.689 0 7v2h4.638c.129-.178.215-.267.387-.4z"}})])])
          )
        }
      }
    